import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url"]

  copy(event) {
    const btn = event.currentTarget
    this.urlTarget.select()

    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.urlTarget.value)
    } else {
      document.execCommand("copy")
    }

    const original = btn.innerHTML
    btn.classList.add("btn-success")
    btn.innerHTML = '<i class="fa fa-check mr-1"></i>Kopiert'
    setTimeout(() => {
      btn.classList.remove("btn-success")
      btn.innerHTML = original
    }, 2000)
  }
}
